import { cn } from '../../lib/utils'

export interface HorizontalBarRow {
	id:    string
	label: string
	value: number
	color: string
}

export interface HorizontalBarChartProps {
	rows:        HorizontalBarRow[]
	maxValue?:   number
	className?:  string
	formatValue?: (value: number) => string
}

/**
 * CSS bars without recharts: the label sits inside the bar, the value right
 * after its end. The widest bar leaves room for the value.
 */
export function HorizontalBarChart({
	rows,
	maxValue,
	className,
	formatValue,
}: HorizontalBarChartProps) {
	const max = maxValue ?? rows.reduce((acc, r) => Math.max(acc, r.value), 0)
	return (
		<ul className={cn('flex flex-col gap-3', className)}>
			{rows.map((row) => {
				const ratio = max > 0 ? row.value / max : 0
				return (
					<li key={row.id} className="flex items-center gap-2 text-sm">
						<div
							className="flex h-8 min-w-20 shrink-0 items-center rounded-(--radius-md) px-3 text-white"
							style={{ width: `calc((100% - 3.5rem) * ${ratio})`, backgroundColor: row.color }}
						>
							<span className="truncate">{row.label}</span>
						</div>
						<span className="text-(--color-foreground)">
							{formatValue ? formatValue(row.value) : row.value}
						</span>
					</li>
				)
			})}
		</ul>
	)
}
